import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Dubai_Festival_City.webp';

const Project_one = () => {

  return (
    <>
       
             <div className='project_1_work' id="workBanner">
       
               <div className="container project_our_work">
       
                 <div className="heading">
                   <h1>Dubai Festival City</h1>
                 </div>
       
                 <hr></hr>
                 <div className='project_section'>
                   <div className="project_section_content">
                     <h1 className="project_scope">Scope of Work</h1>
                     <p>A 1.7 km waterfront mixed-use development along the Dubai Creek developed by Al Futtaim Group. Dubai Festival City
                        encompasses retail, hospitality, residential and commercial components including the iconic Festival Arena entertainment and
                        events venue.</p>
                     <p>MAIN CONTRACTOR : -</p>
                     <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                     <p>GEMCO SCOPE OF WORKS : Various MEP works</p>
                     {/* <h2 className="project_years">2014 – 2022</h2> */}
                   </div>
                   <div className='project_1_card'>
                     <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                   </div>
                 </div>
               </div>
             </div>
       
           </>

  )
}

export default Project_one